import React from 'react';

export interface Props {
  className?: string;
  variant?: 'large';
  alignment?: 'left' | 'center';
  heading: string;
  subheading: string;
  text?: string;
  buttonText?: string;
  buttonClass?: string;
  buttonHref?: string;
}

const PdlTextBlock = ({ alignment = 'left', ...props }: Props) => {
  return (
    <div className={`text-${alignment} ${props.className}`}>
      {props.variant === 'large' ? (
        <>
          <h1 className='public-displays__title'>{props.heading}</h1>
          <h2 className='public-displays__subtitle'>{props.subheading}</h2>
        </>
      ) : (
        <>
          <h3 className='public-displays__title'>{props.heading}</h3>
          <h4 className='public-displays__subtitle'>{props.subheading}</h4>
        </>
      )}
      {props.text ? <p className='public-displays__text'>{props.text}</p> : null}
      {props.buttonText && props.buttonHref ? (
        <a className={`btn ${props.buttonClass}`} href={props.buttonHref}>
          {props.buttonText}
        </a>
      ) : null}
    </div>
  );
};

export default PdlTextBlock;
